export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Usuario",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Usuario",
  tipo:"I"
}

export const ADDCENTERS: ActionType = {
  title:"Agregar Centros",
  tipo:"A"
}